//Database utility constants

export const UPDATE_WHITELIST_ATTEMPT = "UPDATE_WHITELIST_ATTEMPT";
export const UPDATE_WHITELIST_SUCCESS = "GET_DEVICES_SUCCESS";
export const UPDATE_WHITELIST_FAILURE = "GET_DEVICES_FAILURE";
export const GET_PUBLIC_IP_ADDRESS_SUCCESS = "GET_PUBLIC_IP_ADDRESS_SUCCESS";
export const GET_PUBLIC_IP_ADDRESS_FAILURE = "GET_PUBLIC_IP_ADDRESS_FAILURE";
export const GET_PUBLIC_IP_ADDRESS_ATTEMPT = "GET_PUBLIC_IP_ADDRESS_ATTEMPT";
export const CLEAR_STATE = "CLEAR_STATE";
